import Vue from 'vue';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import PayQueue from './cards/payQueue/PayQueue';
import ReadyToPay from './cards/readyToPay/ReadyToPay';
import RecentlyExportedCsvs from './cards/exportedCsvs/RecentlyExportedCsvs';
import RecentlyMarkedPaid from './cards/recentlyPaid/RecentlyMarkedPaid';

export default Vue.extend({
  name: 'ProviderPayments',
  components: {
    PayQueue,
    ReadyToPay,
    RecentlyExportedCsvs,
    RecentlyMarkedPaid
  },
  data () {
    return {
      isAuthorized: false
    }
  },
  beforeMount () {
    this.isAuthorized = this.$store.getters['user/hasRole']([
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ]);
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/ProviderPayments.ts